export default __webpack_public_path__ + "static/media/touchpoint_wall.ae759873.jpg";